import { MinusIcon as PhosphorMinusIcon } from "@phosphor-icons/react/dist/ssr/Minus";

import { createAppIcon } from "@/components/createAppIcon";

export const TrendingFlatIcon = /* @__PURE__ */ createAppIcon(PhosphorMinusIcon);
